import { Card, Descriptions, Typography } from 'antd';
import { formatDateTime } from 'utils/formatDate';
import { LookupTag } from './config';
import {
  getReportResultUrl,
  surveyReportStatuses,
  surveyReportTypes,
} from './constants';

const ItemDetail = ({ item }) => {
  const resultUrl = getReportResultUrl(item);

  return (
    <Card>
      <Descriptions column={1} bordered>
        <Descriptions.Item label="Name">{item.user_name}</Descriptions.Item>
        <Descriptions.Item label="Email">{item.email}</Descriptions.Item>
        <Descriptions.Item label="Phone">{item.phone || '-'}</Descriptions.Item>
        <Descriptions.Item label="Company">
          {item.company_name}
        </Descriptions.Item>
        <Descriptions.Item label="Type">
          <LookupTag map={surveyReportTypes} value={item.type} />
        </Descriptions.Item>
        <Descriptions.Item label="Status">
          <LookupTag map={surveyReportStatuses} value={item.status} />
        </Descriptions.Item>
        <Descriptions.Item label="Report Code">
          {item.code ? (
            <Typography.Text copyable code>
              {item.code}
            </Typography.Text>
          ) : (
            '-'
          )}
        </Descriptions.Item>
        {resultUrl && (
          <Descriptions.Item label="Result">
            <a target="_blank" rel="noreferrer" href={resultUrl}>
              View report
            </a>
          </Descriptions.Item>
        )}
        <Descriptions.Item label="Report ID">
          <Typography.Text copyable type="secondary">
            {item.id}
          </Typography.Text>
        </Descriptions.Item>
        <Descriptions.Item label="Survey ID">
          <Typography.Text copyable type="secondary">
            {item.survey_id}
          </Typography.Text>
        </Descriptions.Item>
        <Descriptions.Item label="Metadata">{item.metadata}</Descriptions.Item>
        <Descriptions.Item label="Created At">
          {formatDateTime(item.created_at)}
        </Descriptions.Item>
        <Descriptions.Item label="Updated At">
          {formatDateTime(item.updated_at)}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

export default ItemDetail;
